export default __webpack_public_path__ + "static/media/cof_active.7ef03dfc.png";